// extracted by mini-css-extract-plugin
export var backButton = "_w-1";
export var content = "_w-d";
export var continueButton = "_w-7";
export var continueHint = "_w-8";
export var continueRow = "_w-6";
export var leftInner = "_w-0";
export var shell = "_w-e";
export var sidebarContent = "_w-5";
export var skipButton = "_w-c";
export var spacer = "_w-2";
export var spin = "_w-a";
export var spinner = "_w-9";
export var spinnerOverlay = "_w-b";
export var subtitle = "_w-4";
export var title = "_w-3";